// extracted by mini-css-extract-plugin
export default {"headingContainer":"Client_headingContainer__MjAxd","subheading":"Client_subheading__1ktc9","heading":"Client_heading__s5GcT"};